import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

const ArticleList = (props) => {
    const { content } = props;

    return (
        <div className={styles.articleList}>
            <div className={styles.mainImage}>
                {
                    content && content[0] &&
                        <a href={content[0].url} target="_blank" rel="noreferrer">
                            <div className={styles.imgWp}>
                                <img src={formatImage(getThumbnail(content[0]), 300 * 2, 169 * 2)} alt={content[0].title} />
                            </div>
                            <div className={styles.title}>{content[0].title}</div>
                        </a>
                }
            </div>
            <div className={styles.articles}>
                {
                    content.slice(1).map((item, index) => {
                        return (
                            <div className={styles.article} key={index}>
                                <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

ArticleList.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(ArticleList);
